import { createGlobalStyle } from "styled-components";
import NexaRegularV2Woff2 from "./../fonts/NexaRegular/3652d7df-f4e3-4d89-bb8d-4e8f646b5e6f.woff2";
import NexaHeavyV2Woff2 from "../fonts/NexaHeavy/fb572dbc-f1ee-44ca-883e-088c704f543e.woff2";
import DinRoundPro from "../fonts/DinRoundPro/DinRoundPro.woff2";
import DinRoundProBlack from "../fonts/DinRoundPro-Black/DinRoundPro-Black.woff2";

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: "NexaRegular";
    src: url(${NexaRegularV2Woff2}) format("woff2");
  }
  
  @font-face {
    font-family: "NexaHeavy";
    src: url(${NexaHeavyV2Woff2}) format("woff2");
  }

  @import url("https://p.typekit.net/p.css?s=1&k=nps5kje&ht=tk&f=35366.35374&a=734606&app=typekit&e=css");

  @font-face {
    font-family:"brother-1816";
    src:url("https://use.typekit.net/af/69907d/00000000000000003b9b32e1/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff2"),url("https://use.typekit.net/af/69907d/00000000000000003b9b32e1/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff"),url("https://use.typekit.net/af/69907d/00000000000000003b9b32e1/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("opentype");
    font-display:auto;
    font-style:normal;
    font-weight:400;
    font-stretch:normal;
  }

  @font-face {
    font-family:"brother-1816-heavy";
    src:url("https://use.typekit.net/af/be70b8/00000000000000003b9b32e8/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("woff2"),url("https://use.typekit.net/af/be70b8/00000000000000003b9b32e8/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("woff"),url("https://use.typekit.net/af/be70b8/00000000000000003b9b32e8/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("opentype");
    font-display:auto;
    font-style:normal;
    font-weight:900;
    font-stretch:normal;
  }


  @font-face {
    font-family: "objektiv mk1";
    src: url("https://use.typekit.net/af/fdbde9/00000000000000007735fd85/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff2"),url("https://use.typekit.net/af/fdbde9/00000000000000007735fd85/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff"),url("https://use.typekit.net/af/fdbde9/00000000000000007735fd85/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("opentype");
    font-display:auto;font-style:normal;font-weight:400;font-stretch:normal;
  }

  @font-face {
    font-family:"objektiv mk1-heavy";
    src:url("https://use.typekit.net/af/7bfe96/00000000000000007735fd7f/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff2"),url("https://use.typekit.net/af/7bfe96/00000000000000007735fd7f/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff"),url("https://use.typekit.net/af/7bfe96/00000000000000007735fd7f/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("opentype");
    font-display:auto;font-style:normal;font-weight:700;font-stretch:normal;
  }


  @font-face {
    font-family: "din-2014-rounded-variable-regular";
    src: url(${DinRoundPro}) format("woff2");
    font-display: auto;
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
  }

  @font-face {
    font-family: "din-2014-rounded-variable-heavy";
    font-weight: 900;
    src: url(${DinRoundProBlack}) format("woff2");
    font-display: auto;
    font-style: normal;
    font-stretch: normal;
  }
`;

export default GlobalStyles;
